module.exports = "/_next/static/images/kate-hudson@3x-1ce7bd848cb367557d294ec27528a34a.png";